import axios from 'axios';
const apiUrl = '/'

const api = axios.create({
    baseURL: `${apiUrl}`,
    timeout: 50000,
    headers: {
        'Content-Type': 'application/json',
    },
});

export const searchByParcelNumber = async (city, parcelNumber) => {
    try {
        const response = await api.get('/api/search/parcelNumber', {
            params: {
                city,
                parcelNumber,
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching:', error);
        throw error;
    }
};

export const searchByAddress = async (city, street, buildingNr, apartmentNr) => {
    try {
        const response = await api.get('/api/search/address', {
            params: {
                city,
                street,
                buildingNr,
                apartmentNr
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching:', error);
        throw error;
    }
};

export const searchById = async (id) => {
    try {
        const response = await api.get('/api/search/id', {
            params: {
                id
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching:', error);
        throw error;
    }
};

export const fetchCities = async (phrase ) => {
    try {
        const response = await api.get('/api/search/cities', {
            params: {
                phrase
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching:', error);
        throw error;
    }
};

export const fetchStreets = async (phrase , city) => {
    try {
        const response = await api.get('/api/search/streets', {
            params: {
                phrase,
                city
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching:', error);
        throw error;
    }
};

export const getParcelRender = async (id) => {
    try {
        const response = await api.get('/api/parcelImg', {
            params: {
                id,
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching:', error);
    }
};

export const getCityById = async (id) => {
    try {
        const response = await api.get('/api/getCityById', {
            params: {
                id,
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching:', error);
    }
};

export const getStreetById = async (id) => {
    try {
        const response = await api.get('/api/getStreetById', {
            params: {
                id,
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching:', error);
    }
};

export const startPayment = async (price, productName, email, userId, lp, packageSize) => {
    try {
        const response = await api.post('/api/orders/create-checkout-session', {
            price,
            productName,
            email,
            userId,
            lp,
            packageSize
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching:', error);
        throw error;
    }
};

export const revealKw = async (email, lp) => {
    try {
        const response = await api.post('/api/orders/reveal', {
            email,
            lp,
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching:', error);
        throw error;
    }
};
